class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!this.els.trigger?.exists) return

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.els.trigger.element.addEventListener(
      'click',
      this.handleTriggerClick,
      { passive: true },
    )

    if (window.location.hash === '#size-guide') {
      setTimeout(() => {
        window.drawers.activeDrawerKey = 'size-guide'
      }, 200)
    }
  }

  disconnectedCallback () {
    if (!this.els.trigger?.exists) return

    this.els.trigger.element.removeEventListener(
      'click',
      this.handleTriggerClick,
    )
  }

  handleTriggerClick () {
    const newSize = this.currentSize === 'in' ? 'cm' : 'in'
    this.currentSize = newSize
    this.setCartAttribute(newSize)
  }

  setCartAttribute (size) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: { current_size: size } }),
    })
  }

  get currentSize () {
    return this.getAttribute('current-size') || 'in'
  }

  set currentSize (value) {
    this.setAttribute('current-size', value)
    this.classList.toggle('drw-SizeGuide_Chart-in', value === 'in')
    this.classList.toggle('drw-SizeGuide_Chart-cm', value === 'cm')
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
